<!--学校管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="9" ></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="学校名称： ">
                  <el-input
                    placeholder="请输入学校名称..."
                    v-model="search.SCHOOL_NAME"
                  ></el-input>
                  <label style="margin-left:6px;">区域：</label>
                  <el-autocomplete
                    v-model="search.CITY_NAME"
                    placeholder="请选择区域..."
                    clearable
                    @select="searchCityHandleSelect"
                    :fetch-suggestions="cityQuerySearchAsync"
                    style="width:200px"
                  ></el-autocomplete>
                  
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                  <el-button
                    type="warning"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="addHandler"
                  >
                    添加学校
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
        <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                @click="roleBgHandler(scope.row)"
                type="text"
                size="small"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            >
            </el-table-column>
          </template>
          
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->

      <!-- 编辑对话框 开始 -->
      <el-dialog
        :title="czData.flag==='ADD'?'添加学校':'修改学校'"
        :visible.sync="dialogVisible"
        width="86%"
      >
        <span>
          <div class="addClassModel">
            <div style="font-size: 17px;font-weight: 600;text-align: left;margin-bottom: 20px;">
                基础设置
            </div>
            <div style="margin-bottom:20px">
                <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">学校名称<span style="color:red">*</span>：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_NAME"
                    style="width:80%;"
                    placeholder="请输入学校名称..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">电话：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_PHONE"
                    style="width:80%;"
                    placeholder="请输入电话..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                    <label style="margin-left:6px;">地址：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_ADDRESS"
                    style="width:80%;"
                    placeholder="请输入地址..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>
            <div style="margin-bottom:20px">
                <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">公众号：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_OFFICIAL_ACCOUNTS"
                    style="width:80%;"
                    placeholder="请输入公众号..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">网址：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_URL"
                    style="width:80%;"
                    placeholder="请输入网址..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                    <label style="margin-left:6px;">学校级别：</label>
                  <el-select
                    v-model="czData.row.SCHOOL_LEVEL"
                    style="width:80%;"
                    placeholder="请选择学校级别..."
                  >
                    <el-option label="小学" value="1"></el-option>
                    <el-option label="中学" value="2"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
            <div style="margin-bottom:20px">
                <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">经度：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_LONGITUDE"
                    style="width:80%;"
                    placeholder="请输入经度..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">纬度：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_LATITUDE"
                    style="width:80%;"
                    placeholder="请输入纬度..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                    <label style="margin-left:6px;">学校范围：</label>
                  <el-input
                    v-model="czData.row.SCHOOL_SCOPE"
                    style="width:80%;"
                    placeholder="请输入学校范围..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="font-size: 17px;font-weight: 600;text-align: left;margin-bottom: 20px;">
                区域设置
            </div>
            <div style="margin-bottom:20px">
                <el-row>
                <el-col :span="8" style="text-align: left;">
                  <el-autocomplete
                  v-model="czData.row.CITY_NAME"
                  placeholder="区域..."
                  clearable
                  @select="formCityHandleSelect"
                  @clear="handleFormCityClear"
                  :fetch-suggestions="cityQuerySearchAsync"
                  style="width:390px"
                >
                  <template slot="prepend">
                    区域：
                    </template>
                </el-autocomplete>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                </el-col>
                <el-col :span="8" style="text-align: left;">
                </el-col>
              </el-row>
            </div>

            <div style="font-size: 17px;font-weight: 600;text-align: left;margin-bottom: 20px;">
                详细信息
            </div>
            <div style="margin-bottom:20px">
                <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label style="margin-left:6px;">施教范围：</label>
                  <textarea v-model="czData.row.TEACH_SCOPE" style="width:80%;height:100px;"></textarea>
                </el-col>
              </el-row>
            </div>
            <div style="margin-bottom:20px">
                <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label style="margin-left:6px;">简介：</label>
                  <textarea v-model="czData.row.SCHOOL_INTRO" style="width:80%;height:100px;"></textarea>
                </el-col>
              </el-row>
            </div>
            <div style="margin-bottom:20px">
                <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label style="margin-left:6px;">共享学区备注：</label>
                  <textarea v-model="czData.row.SHARE_DISTRICT_COMMENT" style="width:80%;height:100px;"></textarea>
                </el-col>
              </el-row>
            </div>

            <!-- 学校图片 - 已隐藏 -->
            <div style="margin-bottom:20px" v-if="false">
                <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;学校图片：</label>
                  <div style="display:inline-block; width:95%; vertical-align:top;">
                    <el-upload
                      class="upload-demo"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-success="handleSchoolImageSuccess"
                      :before-upload="beforeSchoolImageUpload"
                      :on-remove="handleSchoolImageRemove"
                      :file-list="schoolImageFileList"
                      :limit="10"
                      accept="image/*"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip" style="margin-top: 10px; font-size: 12px; color: #909399;">
                      可以上传多张 JPG/PNG 图片，每张不超过 5MB
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 家长群二维码 - 已隐藏 -->
            <div style="margin-bottom:20px" v-if="false">
                <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;家长群二维码：</label>
                  <div style="display:inline-block; width:95%; vertical-align:top;">
                    <el-upload
                      class="upload-demo"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-success="handleParentCodeImageSuccess"
                      :before-upload="beforeParentCodeImageUpload"
                      :on-remove="handleParentCodeImageRemove"
                      :file-list="parentCodeImageFileList"
                      :limit="1"
                      accept="image/*"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip" style="margin-top: 10px; font-size: 12px; color: #909399;">
                      只能上传1张 JPG/PNG 图片，且不超过 5MB
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="addOrEditorOrDel">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 编辑对话框 结束 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "SchoolGlIndex",
  components: { NavCom },
  data() {
    return {
      rows: [],
      search: {
        SCHOOL_NAME: "",
        CITY_ID: "",
        CITY_NAME: ""
      },
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableColumns: [
        {
          colName: "SCHOOL_ID",
          colText: "学校ID",
          colShow: false
        },
        {
          colName: "SCHOOL_NAME",
          colText: "学校名称",
          colShow: true
        },
        {
          colName: "CITY_ID",
          colText: "城市ID",
          colShow: false
        },
        {
          colName: "SCHOOL_PHONE",
          colText: "电话",
          colShow: true
        },
        {
          colName: "SCHOOL_ADDRESS",
          colText: "地址",
          colShow: true
        },
        {
          colName: "SCHOOL_OFFICIAL_ACCOUNTS",
          colText: "公众号",
          colShow: true
        },
        {
          colName: "SCHOOL_URL",
          colText: "网址",
          colShow: true
        },
        {
          colName: "TEACH_SCOPE",
          colText: "施教范围",
          colShow: false
        },
        {
          colName: "SCHOOL_INTRO",
          colText: "简介",
          colShow: false
        },
        {
          colName: "SCHOOL_LEVEL",
          colText: "学校级别",
          colShow: true
        },
        {
          colName: "SCHOOL_LONGITUDE",
          colText: "经度",
          colShow: true
        },
        {
          colName: "SCHOOL_LATITUDE",
          colText: "纬度",
          colShow: true
        },
        {
          colName: "SCHOOL_SCOPE",
          colText: "学校范围",
          colShow: true
        },
        {
          colName: "SCHOOL_IMAGE_IDS",
          colText: "图片地址",
          colShow: false
        },
        {
          colName: "PARENTS_CODE_IMAGES",
          colText: "家长群二维码",
          colShow: false
        },
        {
          colName: "SHARE_DISTRICT_COMMENT",
          colText: "共享学区备注",
          colShow: false
        },
        {
          colName: "VILLAGE_NUM",
          colText: "划区小区数量",
          colShow: true
        },
        {
          colName: "HOUSE_NUM",
          colText: "划区房源数量",
          colShow: true
        },
        {
          colName: "SALE_HOUSE_NUM",
          colText: "划区在售房源数量",
          colShow: true
        },
        {
          colName: "SCHOOL_CREATE_TIME",
          colText: "创建时间",
          colShow: true
        }
      ],
      tableData: [],
      czData:{
        row:{},
        flag:'ADD'
      },
      dialogVisible:false,
      uploadImgUrl: allParam.uploadImgUrl,
      schoolImageFileList: [],
      parentCodeImageFileList: []
    };
  },
  created() {
    this.op = "adminCommunityGl";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "schoolMainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    roleBgHandler(row){
        this.czData.row = JSON.parse(JSON.stringify(row));
        this.czData.flag='UPT';
        // 处理图片列表
        this.schoolImageFileList = [];
        this.parentCodeImageFileList = [];
        if(row.SCHOOL_IMAGE_IDS){
          try {
            const imageIds = row.SCHOOL_IMAGE_IDS.split(',');
            imageIds.forEach(id => {
              if(id && id.trim()){
                this.schoolImageFileList.push({
                  name: id,
                  url: allParam.downMbUrl + id
                });
              }
            });
          } catch(e) {
            console.error("解析学校图片失败", e);
          }
        }
        if(row.PARENTS_CODE_IMAGES){
          try {
            const imageIds = row.PARENTS_CODE_IMAGES.split(',');
            if(imageIds.length > 0 && imageIds[0] && imageIds[0].trim()){
              this.parentCodeImageFileList.push({
                name: imageIds[0],
                url: allParam.downMbUrl + imageIds[0]
              });
            }
          } catch(e) {
            console.error("解析家长群二维码失败", e);
          }
        }
        this.dialogVisible=true
    },
    addHandler(){
        this.czData.flag='ADD';
        this.czData.row = {};
        this.schoolImageFileList = [];
        this.parentCodeImageFileList = [];
        this.dialogVisible=true
    },
    /**分页方法 结束 */
    addOrEditorOrDel(){
        if(!this.czData.row.SCHOOL_NAME){
            alert('请输入学校名称');
            return
        }
        if(!this.czData.row.CITY_ID){
            alert('请选择所属区域');
            return
        }
      if(!confirm('是否提交？')){
            return;
        }
        var busData = {
            row:this.czData.row,
            flag:this.czData.flag
        };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "schoolAddOrEditorOrDel" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
         alert(data.msg);
        if (data.isSuccess) {
            this.mainLoad();
            this.dialogVisible=false
          return;
        }
      });
    },
    //公共方法
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.indexOf(queryString) > -1
        );
      };
    },
    /**选择区域 开始 */
     cityQuerySearchAsync(queryString, cb) {
        var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "getCity" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPostNoLoading().then(data => {
        
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        var restaurants = data.content;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 100);
      });
      
    },
    
    searchCityHandleSelect(item) {
        this.search.CITY_ID = item.CITY_ID;
        this.search.CITY_NAME = item.CITY_NAME;
    },
    formCityHandleSelect(item) {
        this.czData.row.CITY_ID = item.CITY_ID;
        this.czData.row.CITY_NAME = item.CITY_NAME;
    },
    handleFormCityClear() {
        this.czData.row.CITY_ID = "";
        this.czData.row.CITY_NAME = "";
    },
    /**选择区域 结束 */

    // 学校图片上传成功
    handleSchoolImageSuccess(response, file, fileList) {
      if (response.isSuccess) {
        const imageId = response.content.filePath || response.content.url || "";
        if(imageId){
          if(!this.czData.row.SCHOOL_IMAGE_IDS){
            this.czData.row.SCHOOL_IMAGE_IDS = "";
          }
          if(this.czData.row.SCHOOL_IMAGE_IDS){
            this.czData.row.SCHOOL_IMAGE_IDS += "," + imageId;
          } else {
            this.czData.row.SCHOOL_IMAGE_IDS = imageId;
          }
        }
        this.$message.success("图片上传成功");
      } else {
        this.$message.error("上传失败：" + response.msg);
      }
    },
    // 学校图片上传前校验
    beforeSchoolImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5MB = file.size / 1024 / 1024 < 5;
      
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt5MB) {
        this.$message.error("上传的图片大小不能超过 5MB!");
        return false;
      }
      
      return isJPG && isLt5MB;
    },
    // 学校图片移除
    handleSchoolImageRemove(file, fileList) {
      if(file.response && file.response.isSuccess){
        const imageId = file.response.content.filePath || file.response.content.url || "";
        if(imageId && this.czData.row.SCHOOL_IMAGE_IDS){
          const imageIds = this.czData.row.SCHOOL_IMAGE_IDS.split(',');
          const index = imageIds.indexOf(imageId);
          if(index > -1){
            imageIds.splice(index, 1);
            this.czData.row.SCHOOL_IMAGE_IDS = imageIds.join(',');
          }
        }
      } else if(file.name){
        // 处理已有图片的删除
        const imageIds = this.czData.row.SCHOOL_IMAGE_IDS ? this.czData.row.SCHOOL_IMAGE_IDS.split(',') : [];
        const index = imageIds.indexOf(file.name);
        if(index > -1){
          imageIds.splice(index, 1);
          this.czData.row.SCHOOL_IMAGE_IDS = imageIds.join(',');
        }
      }
    },

    // 家长群二维码上传成功
    handleParentCodeImageSuccess(response, file, fileList) {
      if (response.isSuccess) {
        const imageId = response.content.filePath || response.content.url || "";
        if(imageId){
          this.czData.row.PARENTS_CODE_IMAGES = imageId;
        }
        this.$message.success("图片上传成功");
      } else {
        this.$message.error("上传失败：" + response.msg);
      }
    },
    // 家长群二维码上传前校验
    beforeParentCodeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5MB = file.size / 1024 / 1024 < 5;
      
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt5MB) {
        this.$message.error("上传的图片大小不能超过 5MB!");
        return false;
      }
      
      return isJPG && isLt5MB;
    },
    // 家长群二维码移除
    handleParentCodeImageRemove(file, fileList) {
      this.czData.row.PARENTS_CODE_IMAGES = "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/communityGlIndex/SchoolGlIndex.vue